/*eslint-disable*/
import { HamburgerIcon } from "@chakra-ui/icons";
import {
    Avatar,
    Box,
    Button,
    Divider,
    Drawer,
    DrawerBody,
    DrawerCloseButton,
    DrawerContent,
    DrawerOverlay,
    Flex,
    Icon,
    Link,
    Stack,
    Text,
    Tooltip,
    useColorModeValue,
    useDisclosure,
    VStack,
} from "@chakra-ui/react";
import IconBox from "components/Icons/IconBox";
import PropTypes from "prop-types";
import { useAuth } from "Providers/AuthProvider";
import React from "react";
import { FaLock } from "react-icons/fa";
import { TbLogout, TbChevronRight, TbSparkles } from "react-icons/tb";
import { useAiChat } from "Providers/AiChatProvider";
import { NavLink, useLocation, useHistory } from "react-router-dom";
import wsClimaLogo from "assets/img/wsclima.png";
import inmetLogo from "assets/img/inmet.webp";

// FUNCTIONS
function greeting() {
    let greeting = "";
    var data = [
        [0, 4, "Boa noite"],
        [5, 11, "Bom dia"],
        [12, 17, "Boa tarde"],
        [18, 24, "Boa noite"],
    ],
        hr = new Date().getHours();

    for (var i = 0; i < data.length; i++) {
        if (hr >= data[i][0] && hr <= data[i][1]) {
            greeting = data[i][2];
        }
    }
    return greeting;
}

function getInitials(name) {
    if (!name) return "U";
    const words = name.trim().split(" ");
    if (words.length === 1) return words[0][0].toUpperCase();
    return (words[0][0] + words[words.length - 1][0]).toUpperCase();
}

function Sidebar(props) {
    const auth = useAuth();
    const aiChat = useAiChat();
    const history = useHistory();
    let location = useLocation();
    const [state, setState] = React.useState({});
    const mainPanel = React.useRef();
    let variantChange = "0.2s linear";

    const activeRoute = (routeName) => {
        return location.pathname === routeName ? "active" : "";
    };

    // Colors - moved to top level for proper hook usage
    const sidebarBgColor = useColorModeValue("white", "gray.800");
    const activeBg = useColorModeValue("brand.50", "brand.900");
    const inactiveBg = useColorModeValue("gray.100", "gray.700");
    const hoverBg = useColorModeValue("gray.100", "gray.700");
    const textColor = useColorModeValue("gray.700", "gray.200");
    const mutedColor = useColorModeValue("gray.500", "gray.400");
    const dividerColor = useColorModeValue("gray.200", "gray.600");
    const sectionLabelColor = useColorModeValue("gray.500", "gray.400");

    const createLinks = (routes, type) => {
        return routes.map((prop, key) => {
            if (prop.adminOnly && !auth.getUser().admin) return;

            let isLocked = prop.lock ? !auth.getUser().membership : false;
            let isModuleLocked = prop.isModule ? !auth.getUser().admin : false;

            if (isModuleLocked) {
                isModuleLocked = prop.module ? !(auth.getUser().modules || []).find(module => module.name == prop.module) : true;
                if (isModuleLocked && prop.userHas) {
                    isModuleLocked = !auth.getUser()[prop.userHas] || auth.getUser()[prop.userHas]?.length == 0;
                }
            }

            if (prop.type != type) return;
            if (prop.redirect || prop.menu === false) {
                return null;
            }
            if (prop.category) {
                var st = {};
                st[prop["state"]] = !state[prop.state];
                return (
                    <Box key={key}>
                        <Text
                            fontSize="xs"
                            fontWeight="semibold"
                            color={sectionLabelColor}
                            textTransform="uppercase"
                            letterSpacing="wider"
                            mb={2}
                            mt={4}
                            px={3}
                        >
                            {prop.name}
                        </Text>
                        {createLinks(prop.views, type)}
                    </Box>
                );
            }
            return (
                <NavLink
                    to={isLocked ? "/members/account" : (isModuleLocked ? "/members/module-locked" : prop.path)}
                    key={"create_links" + key}
                >
                    {activeRoute(prop.path) === "active" ? (
                        <Flex
                            align="center"
                            p={3}
                            mx={2}
                            borderRadius="xl"
                            bg={activeBg}
                            border="2px solid"
                            borderColor="brand.500"
                            boxShadow="0 4px 12px rgba(45, 107, 63, 0.15)"
                            transition={variantChange}
                            cursor="pointer"
                            opacity={isLocked || isModuleLocked ? 0.5 : 1}
                            role="group"
                        >
                            <IconBox
                                bg="brand.500"
                                color="white"
                                h="32px"
                                w="32px"
                                me={3}
                                borderRadius="lg"
                            >
                                {isLocked || isModuleLocked ? <FaLock size={14} /> : prop.icon}
                            </IconBox>
                            <Text fontSize="sm" fontWeight="semibold" color={textColor}>
                                {prop.name}
                            </Text>
                            <Icon as={TbChevronRight} ml="auto" color="brand.500" />
                        </Flex>
                    ) : (
                        <Flex
                            align="center"
                            p={3}
                            mx={2}
                            borderRadius="xl"
                            bg="transparent"
                            transition="all 0.2s ease"
                            cursor="pointer"
                            _hover={{
                                bg: hoverBg,
                                transform: "translateX(4px)",
                            }}
                            opacity={isLocked || isModuleLocked ? 0.5 : 1}
                            role="group"
                        >
                            <IconBox
                                bg={inactiveBg}
                                color="brand.500"
                                h="32px"
                                w="32px"
                                me={3}
                                borderRadius="lg"
                                transition={variantChange}
                                _groupHover={{ bg: "brand.500", color: "white" }}
                            >
                                {isLocked || isModuleLocked ? <FaLock size={14} /> : prop.icon}
                            </IconBox>
                            <Text fontSize="sm" fontWeight="medium" color={textColor}>
                                {prop.name}
                            </Text>
                        </Flex>
                    )}
                </NavLink>
            );
        });
    };

    const { logoText, routes, sidebarVariant } = props;
    const user = auth.getUser();

    var linksMember = <>{createLinks(routes, "member")}</>;
    var linksAdmin = <>{createLinks(routes, "admin")}</>;

    let sidebarBg = sidebarVariant === "opaque" ? sidebarBgColor : "none";
    let sidebarRadius = sidebarVariant === "opaque" ? "16px" : "0px";
    let sidebarMargins = sidebarVariant === "opaque" ? "16px 0px 16px 16px" : "0px";

    const handleLogout = () => {
        auth.logout();
        history.push("/");
    };

    var brand = (
        <Box pb={2}>
            {/* Brand Header with Logo */}
            <Box
                bg="linear-gradient(135deg, #2D6B3F 0%, #1F5A2F 100%)"
                p={4}
                mb={4}
            >
                <Link href="/" _hover={{ textDecoration: "none" }}>
                    <VStack spacing={2}>
                        <Flex align="center" justify="center">
                            <Box
                                as="img"
                                src={wsClimaLogo}
                                alt="WS Clima Logo"
                                w="40px"
                                h="40px"
                                borderRadius="lg"
                                objectFit="contain"
                            />
                            <Tooltip label="Em parceria com INMET" placement="bottom">
                                <Box
                                    as="img"
                                    src={inmetLogo}
                                    alt="INMET Logo"
                                    w="36px"
                                    h="36px"
                                    ml={2}
                                    objectFit="contain"
                                    opacity={0.9}
                                    _hover={{ opacity: 1 }}
                                    transition="opacity 0.2s"
                                />
                            </Tooltip>
                        </Flex>
                        <Box textAlign="center">
                            <Text fontSize="sm" fontWeight="bold" color="white">
                                WS Consultoria
                            </Text>
                            <Text fontSize="xs" color="whiteAlpha.800">
                                Climatológica
                            </Text>
                        </Box>
                    </VStack>
                </Link>
            </Box>

            {/* User Profile Section */}
            <Box
                bg={useColorModeValue("gray.50", "gray.700")}
                borderRadius="xl"
                p={3}
                mx={2}
                mb={4}
            >
                <Flex align="center">
                    <Avatar
                        name={user?.name || "Usuário"}
                        size="sm"
                        bg="brand.500"
                        color="white"
                        mr={3}
                    />
                    <Box flex={1} minW={0}>
                        <Text
                            fontSize="sm"
                            fontWeight="semibold"
                            color={textColor}
                            noOfLines={1}
                        >
                            {user?.name || "Usuário"}
                        </Text>
                        <Text fontSize="xs" color={mutedColor}>
                            {greeting()}
                        </Text>
                    </Box>
                </Flex>
            </Box>

            {/* Section Label */}
            <Text
                fontSize="xs"
                fontWeight="semibold"
                color={sectionLabelColor}
                textTransform="uppercase"
                letterSpacing="wider"
                px={4}
                mb={2}
            >
                Menu Principal
            </Text>
        </Box>
    );

    // SIDEBAR
    return (
        <Box className="sidebar" ref={mainPanel}>
            <Box display={{ sm: "none", xl: "block" }} position="fixed">
                <Box
                    bg={sidebarBg}
                    transition={variantChange}
                    w="260px"
                    maxW="260px"
                    h="calc(100vh)"
                    borderRight="1px solid"
                    borderColor={dividerColor}
                    display="flex"
                    flexDirection="column"
                >
                    {/* Scrollable Content */}
                    <Box flex={1} overflowY="auto" pb={4}>
                        <Box>{brand}</Box>
                        <Stack direction="column" spacing={1}>
                            <Box>{linksMember}</Box>
                            {auth.getUser().admin ? (
                                <>
                                    <Divider my={3} borderColor={dividerColor} />
                                    <Text
                                        fontSize="xs"
                                        fontWeight="semibold"
                                        color={sectionLabelColor}
                                        textTransform="uppercase"
                                        letterSpacing="wider"
                                        px={4}
                                        pt={2}
                                        mb={2}
                                    >
                                        Administrativo
                                    </Text>
                                    <Box>
                                        <Flex
                                            align="center"
                                            p={3}
                                            mx={2}
                                            borderRadius="xl"
                                            bg="transparent"
                                            transition="all 0.2s ease"
                                            cursor="pointer"
                                            _hover={{ bg: hoverBg, transform: "translateX(4px)" }}
                                            role="group"
                                            onClick={() => aiChat.toggle()}
                                        >
                                            <IconBox
                                                bg={inactiveBg}
                                                color="brand.500"
                                                h="32px"
                                                w="32px"
                                                me={3}
                                                borderRadius="lg"
                                                transition={variantChange}
                                                _groupHover={{ bg: "brand.500", color: "white" }}
                                            >
                                                <TbSparkles size={16} />
                                            </IconBox>
                                            <Text fontSize="sm" fontWeight="medium" color={textColor}>
                                                AgroIA WS
                                            </Text>
                                        </Flex>
                                        {linksAdmin}
                                    </Box>
                                </>
                            ) : null}
                        </Stack>
                    </Box>

                    {/* Fixed Footer */}
                    <Box
                        borderTop="1px solid"
                        borderColor={dividerColor}
                        p={3}
                        bg={useColorModeValue("gray.50", "gray.800")}
                    >
                        <Button
                            leftIcon={<TbLogout />}
                            variant="ghost"
                            w="100%"
                            justifyContent="flex-start"
                            color={mutedColor}
                            fontWeight="medium"
                            _hover={{ color: "red.500", bg: useColorModeValue("red.50", "red.900") }}
                            onClick={handleLogout}
                        >
                            Sair
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}

// FUNCTIONS

export function SidebarResponsive(props) {
    const auth = useAuth();
    const aiChat = useAiChat();
    const history = useHistory();
    let location = useLocation();
    const [state, setState] = React.useState({});
    const mainPanel = React.useRef();

    const activeRoute = (routeName) => {
        return location.pathname === routeName ? "active" : "";
    };

    // Colors - moved to top level
    const activeBg = useColorModeValue("brand.50", "brand.900");
    const inactiveBg = useColorModeValue("gray.100", "gray.700");
    const hoverBg = useColorModeValue("gray.100", "gray.700");
    const textColor = useColorModeValue("gray.700", "gray.200");
    const mutedColor = useColorModeValue("gray.500", "gray.400");
    const dividerColor = useColorModeValue("gray.200", "gray.600");
    const sectionLabelColor = useColorModeValue("gray.500", "gray.400");
    const drawerBg = useColorModeValue("white", "gray.800");

    const createLinks = (routes, type) => {
        return routes.map((prop, key) => {
            if (prop.adminOnly && !auth.getUser().admin) return;

            let isLocked = prop.lock ? !auth.getUser().membership : false;
            let isModuleLocked = prop.isModule ? !auth.getUser().admin : false;

            if (isModuleLocked) {
                isModuleLocked = prop.module ? !(auth.getUser().modules || []).find(module => module.name == prop.module) : true;
                if (isModuleLocked && prop.userHas) {
                    isModuleLocked = !auth.getUser()[prop.userHas] || auth.getUser()[prop.userHas]?.length == 0;
                }
            }

            if (prop.type != type) return;
            if (prop.redirect) {
                return null;
            }
            if (prop.category) {
                var st = {};
                st[prop["state"]] = !state[prop.state];
                return (
                    <Box key={key}>
                        <Text
                            fontSize="xs"
                            fontWeight="semibold"
                            color={sectionLabelColor}
                            textTransform="uppercase"
                            letterSpacing="wider"
                            mb={2}
                            mt={4}
                            px={3}
                        >
                            {prop.name}
                        </Text>
                        {createLinks(prop.views, type)}
                    </Box>
                );
            }
            return (
                <NavLink
                    to={isLocked ? "/members/account" : (isModuleLocked ? "/members/module-locked" : prop.path)}
                    key={key}
                >
                    {activeRoute(prop.path) === "active" ? (
                        <Flex
                            align="center"
                            p={3}
                            mx={2}
                            mb={1}
                            borderRadius="xl"
                            bg={activeBg}
                            border="2px solid"
                            borderColor="brand.500"
                            boxShadow="0 4px 12px rgba(45, 107, 63, 0.15)"
                            cursor="pointer"
                            opacity={isLocked || isModuleLocked ? 0.5 : 1}
                        >
                            <IconBox
                                bg="brand.500"
                                color="white"
                                h="32px"
                                w="32px"
                                me={3}
                                borderRadius="lg"
                            >
                                {isLocked || isModuleLocked ? <FaLock size={14} /> : prop.icon}
                            </IconBox>
                            <Text fontSize="sm" fontWeight="semibold" color={textColor}>
                                {prop.name}
                            </Text>
                            <Icon as={TbChevronRight} ml="auto" color="brand.500" />
                        </Flex>
                    ) : (
                        <Flex
                            align="center"
                            p={3}
                            mx={2}
                            mb={1}
                            borderRadius="xl"
                            bg="transparent"
                            transition="all 0.2s ease"
                            cursor="pointer"
                            _hover={{
                                bg: hoverBg,
                                transform: "translateX(4px)",
                            }}
                            opacity={isLocked || isModuleLocked ? 0.5 : 1}
                        >
                            <IconBox
                                bg={inactiveBg}
                                color="brand.500"
                                h="32px"
                                w="32px"
                                me={3}
                                borderRadius="lg"
                            >
                                {isLocked || isModuleLocked ? <FaLock size={14} /> : prop.icon}
                            </IconBox>
                            <Text fontSize="sm" fontWeight="medium" color={textColor}>
                                {prop.name}
                            </Text>
                        </Flex>
                    )}
                </NavLink>
            );
        });
    };

    const { logoText, routes, ...rest } = props;
    const user = auth.getUser();

    var linksMember = <>{createLinks(routes, "member")}</>;
    var linksAdmin = <>{createLinks(routes, "admin")}</>;

    let hamburgerColor = useColorModeValue("gray.500", "gray.200");
    if (props.secondary === true) {
        hamburgerColor = "white";
    }

    const handleLogout = () => {
        auth.logout();
        history.push("/");
    };

    var brand = (
        <Box pb={2}>
            {/* Brand Header with Logo */}
            <Box
                bg="linear-gradient(135deg, #2D6B3F 0%, #1F5A2F 100%)"
                p={4}
                mb={4}
            >
                <Link href="/" _hover={{ textDecoration: "none" }}>
                    <VStack spacing={2}>
                        <Flex align="center" justify="center">
                            <Box
                                as="img"
                                src={wsClimaLogo}
                                alt="WS Clima Logo"
                                w="40px"
                                h="40px"
                                borderRadius="lg"
                                objectFit="contain"
                            />
                            <Tooltip label="Em parceria com INMET" placement="bottom">
                                <Box
                                    as="img"
                                    src={inmetLogo}
                                    alt="INMET Logo"
                                    w="36px"
                                    h="36px"
                                    ml={2}
                                    objectFit="contain"
                                    opacity={0.9}
                                    _hover={{ opacity: 1 }}
                                    transition="opacity 0.2s"
                                />
                            </Tooltip>
                        </Flex>
                        <Box textAlign="center">
                            <Text fontSize="sm" fontWeight="bold" color="white">
                                WS Consultoria
                            </Text>
                            <Text fontSize="xs" color="whiteAlpha.800">
                                Climatológica
                            </Text>
                        </Box>
                    </VStack>
                </Link>
            </Box>

            {/* User Profile Section */}
            <Box
                bg={useColorModeValue("gray.50", "gray.700")}
                borderRadius="xl"
                p={3}
                mx={2}
                mb={4}
            >
                <Flex align="center">
                    <Avatar
                        name={user?.name || "Usuário"}
                        size="sm"
                        bg="brand.500"
                        color="white"
                        mr={3}
                    />
                    <Box flex={1} minW={0}>
                        <Text
                            fontSize="sm"
                            fontWeight="semibold"
                            color={textColor}
                            noOfLines={1}
                        >
                            {user?.name || "Usuário"}
                        </Text>
                        <Text fontSize="xs" color={mutedColor}>
                            {greeting()}
                        </Text>
                    </Box>
                </Flex>
            </Box>

            {/* Section Label */}
            <Text
                fontSize="xs"
                fontWeight="semibold"
                color={sectionLabelColor}
                textTransform="uppercase"
                letterSpacing="wider"
                px={4}
                mb={2}
            >
                Menu Principal
            </Text>
        </Box>
    );

    // SIDEBAR
    const { isOpen, onOpen, onClose } = useDisclosure();
    const btnRef = React.useRef();

    return (
        <Flex
            display={{ sm: "flex", xl: "none" }}
            ref={mainPanel}
            alignItems="center"
        >
            <HamburgerIcon
                color={hamburgerColor}
                w="18px"
                h="18px"
                ref={btnRef}
                onClick={onOpen}
                cursor="pointer"
            />
            <Drawer
                isOpen={isOpen}
                onClose={onClose}
                placement="left"
                finalFocusRef={btnRef}
            >
                <DrawerOverlay bg="blackAlpha.600" backdropFilter="blur(4px)" />
                <DrawerContent
                    w="280px"
                    maxW="280px"
                    borderRightRadius="2xl"
                    shadow="2xl"
                    bg={drawerBg}
                >
                    <DrawerCloseButton
                        _focus={{ boxShadow: "none" }}
                        _hover={{ bg: hoverBg }}
                        borderRadius="lg"
                        top={4}
                        right={4}
                    />
                    <DrawerBody px={0} display="flex" flexDirection="column">
                        <Box flex={1} overflowY="auto">
                            <Box>{brand}</Box>
                            <Stack direction="column" spacing={1}>
                                <Box>{linksMember}</Box>
                                {auth.getUser().admin ? (
                                    <>
                                        <Divider my={3} borderColor={dividerColor} />
                                        <Text
                                            fontSize="xs"
                                            fontWeight="semibold"
                                            color={sectionLabelColor}
                                            textTransform="uppercase"
                                            letterSpacing="wider"
                                            px={4}
                                            mb={2}
                                        >
                                            Administrativo
                                        </Text>
                                        <Box>
                                        <Flex
                                            align="center"
                                            p={3}
                                            mx={2}
                                            mb={1}
                                            borderRadius="xl"
                                            bg="transparent"
                                            transition="all 0.2s ease"
                                            cursor="pointer"
                                            _hover={{ bg: hoverBg, transform: "translateX(4px)" }}
                                            role="group"
                                            onClick={() => { aiChat.toggle(); onClose(); }}
                                        >
                                            <IconBox
                                                bg={inactiveBg}
                                                color="brand.500"
                                                h="32px"
                                                w="32px"
                                                me={3}
                                                borderRadius="lg"
                                                _groupHover={{ bg: "brand.500", color: "white" }}
                                            >
                                                <TbSparkles size={16} />
                                            </IconBox>
                                            <Text fontSize="sm" fontWeight="medium" color={textColor}>
                                                AgroIA WS
                                            </Text>
                                        </Flex>
                                        {linksAdmin}
                                        </Box>
                                    </>
                                ) : null}
                            </Stack>
                        </Box>

                        {/* Fixed Footer */}
                        <Box
                            borderTop="1px solid"
                            borderColor={dividerColor}
                            p={3}
                            mt="auto"
                        >
                            <Button
                                leftIcon={<TbLogout />}
                                variant="ghost"
                                w="100%"
                                justifyContent="flex-start"
                                color={mutedColor}
                                fontWeight="medium"
                                _hover={{ color: "red.500", bg: useColorModeValue("red.50", "red.900") }}
                                onClick={handleLogout}
                            >
                                Sair
                            </Button>
                        </Box>
                    </DrawerBody>
                </DrawerContent>
            </Drawer>
        </Flex>
    );
}

// PROPS
Sidebar.propTypes = {
    logoText: PropTypes.string,
    routes: PropTypes.arrayOf(PropTypes.object),
    variant: PropTypes.string,
};
SidebarResponsive.propTypes = {
    logoText: PropTypes.string,
    routes: PropTypes.arrayOf(PropTypes.object),
};

export default Sidebar;
